import * as Sentry from "@sentry/react";
import { trackBusinessSuccess } from './sentry';

// 비즈니스 핵심 지표 추적
export const trackBusinessMetrics = {
  // 신청서 제출 성공률
  applicationSubmitSuccess: (deviceCount: number, userName: string) => {
    // 커스텀 이벤트로 추적
    Sentry.addBreadcrumb({
      message: '신청서 제출 성공',
      category: 'business_metric',
      data: {
        metric_type: 'application_submit_success',
        device_count: deviceCount,
        has_multiple_devices: deviceCount > 1
      },
      level: 'info'
    });
    
    trackBusinessSuccess('application_submit', '신청서 제출 성공', {
      device_count: deviceCount,
      user_name: userName
    });
  },
  
  // 본인인증 성공률
  authenticationSuccess: (provider: string = 'portone') => {
    Sentry.addBreadcrumb({
      message: '본인인증 성공',
      category: 'business_metric',
      data: {
        metric_type: 'auth_success',
        provider
      },
      level: 'info'
    });
    
    trackBusinessSuccess('auth_complete', '본인인증 성공', { provider });
  },
  
  // 알림톡 전송 성공률
  alertSendSuccess: (eventType: string) => {
    Sentry.addBreadcrumb({
      message: '알림톡 전송 성공',
      category: 'business_metric',
      data: {
        metric_type: 'alert_send_success',
        event_type: eventType
      },
      level: 'info'
    });
    
    trackBusinessSuccess('biztalk_sent', `알림톡 전송 성공: ${eventType}`, {
      event_type: eventType
    });
  },
  
  // 페이지 로드 시간
  pageLoadTime: (pageName: string, loadTime: number) => {
    Sentry.addBreadcrumb({
      message: '페이지 로드 시간 측정',
      category: 'performance',
      data: {
        page: pageName,
        load_time: loadTime
      },
      level: 'info'
    });
  },
  
  // 에러 발생률
  trackError: (errorType: string, errorMessage: string) => {
    Sentry.addBreadcrumb({
      message: '에러 발생 추적',
      category: 'business_metric',
      data: {
        metric_type: 'error_count',
        error_type: errorType,
        error_message: errorMessage
      },
      level: 'error'
    });
  }
}; 